import api from '../config/api';

// Brand API services
export const brandService = {
  // Get all brands
  getBrands: async () => {
    const response = await api.get('/api/brands');
    return response.data;
  },

  // Get brand by ID
  getBrandById: async (id) => {
    const response = await api.get(`/api/brands/${id}`);
    return response.data;
  },

  // Create new brand
  createBrand: async (brandData) => {
    const response = await api.post('/api/brands', brandData);
    return response.data;
  },

  // Update brand
  updateBrand: async (id, brandData) => {
    const response = await api.put(`/api/brands/${id}`, brandData);
    return response.data;
  },

  // Delete brand
  deleteBrand: async (id) => {
    const response = await api.delete(`/api/brands/${id}`);
    return response.data;
  },

  // Get brand users
  getBrandUsers: async (id) => {
    const response = await api.get(`/api/brands/${id}/users`);
    return response.data;
  },

  // Add user to brand
  addUserToBrand: async (id, userData) => {
    const response = await api.post(`/api/brands/${id}/users`, userData);
    return response.data;
  },

  // Remove user from brand
  removeUserFromBrand: async (brandId, userId) => {
    const response = await api.delete(`/api/brands/${brandId}/users/${userId}`);
    return response.data;
  },

  // Get brand connections
  getBrandConnections: async (id) => {
    const response = await api.get(`/api/brands/${id}/connections`);
    return response.data;
  },

  // Add connection to brand
  addConnectionToBrand: async (id, connectionData) => {
    const response = await api.post(`/api/brands/${id}/connections`, connectionData);
    return response.data;
  },

  // Remove connection from brand
  removeConnectionFromBrand: async (brandId, connectionId) => {
    const response = await api.delete(`/api/brands/${brandId}/connections/${connectionId}`);
    return response.data;
  },
};

export default brandService;
